import { useState } from "react"
import * as PropTypes from "prop-types"
import styled from "styled-components"
import Typography from "components/styled/Typography"
import Icon from "components/icons/icon"
import { Plus } from "components/icons/plus"
import { Minus } from "components/icons/minus"
import { sendEvent } from "scripts/GoogleAnalytics"

const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.white};
  overflow: hidden;
  border-bottom: solid 1px ${({ theme }) => theme.colors.lightGray};
  &:last-child {
    border-bottom: none;
  }
`

const Title = styled(Typography)`
  margin: 0;
  max-width: 90%;
  @media ${({ theme }) => theme.breakpoints.lg} {
    font-size: 16px;
    line-height: 18px;
  }
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
  cursor: pointer;
  height: 80px;
`

const Dropdown = styled.div`
  overflow: hidden;
  transition: all 0.5s;
  max-height: 0;
  &.active {
    max-height: 200px;
  }
`

const Text = styled(Typography)`
  margin-bottom: 25px;
  line-height: 18px;
  @media ${({ theme }) => theme.breakpoints.lg} {
    font-size: 14px;
    line-height: 21px;
  }
`

export default function Faq({ question, answer, page, closed }) {
  const [isOpen, setIsOpen] = useState(!closed)

  const toggle = () => {
    if (!isOpen) sendEvent("faq", { event_category: page, event_label: question })
    setIsOpen(!isOpen)
  }

  return (
    <Wrapper>
      <Header onClick={toggle}>
        <Title color="skyBlue" weight="medium">
          {question}
        </Title>
        <Icon color="deepPink" size="xs" Icon={isOpen ? Minus : Plus} />
      </Header>
      <Dropdown className={isOpen ? "active" : ""}>
        <Text variant="small">{answer}</Text>
      </Dropdown>
    </Wrapper>
  )
}

Faq.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
  closed: PropTypes.bool.isRequired
}
